// File: src/app/components/admin/edit-variant-attributes-dialog/edit-variant-attributes-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


@Component({
  selector: 'app-edit-variant-attributes-dialog',
  standalone: true,
  templateUrl: './edit-variant-attributes-dialog.component.html',
  styleUrls: ['./edit-variant-attributes-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon
  ]
})
export class EditVariantAttributesDialogComponent {
  attributes: { [key: string]: string };
  newAttributes: { key: string, value: any, isNew: boolean }[] = [];

  constructor(
    private dialogRef: MatDialogRef<EditVariantAttributesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { attributes: { [key: string]: string } }
  ) {
    this.attributes = { ...data.attributes };
  }


  get attributeKeys(): string[] {
    return Object.keys(this.attributes || {});
  }

  ngOnInit() {
    this.newAttributes = Object.entries(this.data.attributes || {}).map(([key, value]) => ({
      key,
      value,
      isNew: false
    }));
  }

  addAttribute(): void {
    // this.attributes[''] = '';
    this.newAttributes.push({ key: '', value: '', isNew: true });
  }

  removeAttribute(key: string): void {
    this.newAttributes = this.newAttributes.filter(attr => attr.key !== key);
    if (this.attributes.hasOwnProperty(key)) {
      delete this.attributes[key];
    }
  }


  save(): void {
    const updatedAttributes: { [key: string]: string } = { ...this.attributes };

    for (const attr of this.newAttributes) {
      const trimmedKey = attr.key.trim();
      if (!trimmedKey) continue;
      updatedAttributes[trimmedKey] = attr.value;
    }

    this.dialogRef.close(updatedAttributes);
  }

}
